import * as yup from 'yup';
import { FIELD_LIMITS } from 'utils/character-count-utils';
import {
  CertificateTemplate,
  CertificateValidityUnit,
} from '../../../../../interface';

export const MAX_CERTIFICATE_LOGOS = 6;
export const MAX_CERTIFICATE_SIGNATORIES = 4;

export const CERTIFICATE_LOGO_LIMIT_MESSAGE = `You can add up to ${MAX_CERTIFICATE_LOGOS} certificate logos`;
export const CERTIFICATE_SIGNATORY_LIMIT_MESSAGE = `You can add up to ${MAX_CERTIFICATE_SIGNATORIES} certificate signatories`;

const certificateBadgeValidation = yup.object().shape({
  title: yup.string().trim().required('Badge title is a required field').max(FIELD_LIMITS.BADGE_TITLE.maxLength, `Badge title must be at most ${FIELD_LIMITS.BADGE_TITLE.maxLength} characters`),
  description: yup.string().trim().max(FIELD_LIMITS.BADGE_DESC.maxLength, `Badge description must be at most ${FIELD_LIMITS.BADGE_DESC.maxLength} characters`),
  imageUrl: yup.string().trim().required('Badge image is a required field'),
});

const certificateValidityValidation = yup.object().shape({
  value: yup.number()
    .typeError('Validity value is a required field')
    .required('Validity value is a required field')
    .integer('Validity value must be a whole number')
    .positive('Validity value must be greater than zero'),
  unit: yup.string().trim().oneOf(Object.values(CertificateValidityUnit)).required('Validity unit is a required field'),
});

const certificateModalFormValidation = yup.object().shape({
  title: yup.string().trim().required('Title is a required field').max(FIELD_LIMITS.SESSION_NAME.maxLength, `Certificate title must be at most ${FIELD_LIMITS.SESSION_NAME.maxLength} characters`),
  description: yup.string().trim().required('Description is a required field').max(FIELD_LIMITS.SESSION_DESC.maxLength, `Certificate description must be at most ${FIELD_LIMITS.SESSION_DESC.maxLength} characters`),
  template: yup.string().trim().oneOf(Object.values(CertificateTemplate)).required('Template is a required field'),
  header: yup.string().trim().required('Header is a required field').max(FIELD_LIMITS.SESSION_NAME.maxLength, `Certificate header must be at most ${FIELD_LIMITS.SESSION_NAME.maxLength} characters`),
  logos: yup.array().of(
    yup.object().shape({
      title: yup.string().trim().required('Logo title is a required field').max(FIELD_LIMITS.TITLE.maxLength, `Logo title must be at most ${FIELD_LIMITS.TITLE.maxLength} characters`),
      logoUrl: yup.string().trim().required('Logo image is a required field'),
    }),
  ).max(MAX_CERTIFICATE_LOGOS, CERTIFICATE_LOGO_LIMIT_MESSAGE),
  badge: yup.lazy((value) => (
    value === undefined || value === null
      ? yup.mixed().nullable().notRequired()
      : certificateBadgeValidation
  )),
  signatories: yup.array().of(
    yup.object().shape({
      name: yup.string().trim().required('Name is a required field').max(FIELD_LIMITS.NAME.maxLength, `Signatory name must be at most ${FIELD_LIMITS.NAME.maxLength} characters`),
      designation: yup.string().trim().required('Designation is a required field').max(FIELD_LIMITS.TITLE.maxLength, `Designation must be at most ${FIELD_LIMITS.TITLE.maxLength} characters`),
      signatureImageUrl: yup.string().trim().required('Signature image is a required field'),
    }),
  ).max(MAX_CERTIFICATE_SIGNATORIES, CERTIFICATE_SIGNATORY_LIMIT_MESSAGE),
  validity: yup.lazy((value) => (
    value === undefined || value === null
      ? yup.mixed().nullable().notRequired()
      : certificateValidityValidation
  )),
});

export const certificateFieldConfigs = {
  title: FIELD_LIMITS.SESSION_NAME,
  description: FIELD_LIMITS.SESSION_DESC,
  header: FIELD_LIMITS.SESSION_NAME,
  logoTitle: FIELD_LIMITS.TITLE,
  badgeTitle: FIELD_LIMITS.BADGE_TITLE,
  badgeDescription: FIELD_LIMITS.BADGE_DESC,
  signatoryName: FIELD_LIMITS.NAME,
  signatoryDesignation: FIELD_LIMITS.TITLE,
};

export default certificateModalFormValidation;
